import { Route } from '@angular/router'
import { authGuard, permissionGuard } from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type AuditLogRoutes = {
    auditLog: Route
}

export const auditLogRoutes: AuditLogRoutes = {
    auditLog: {
        path: 'dashboard/audit-log',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.auditLog.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-audit-log/page-audit-log.component').then(
                (m) => m.PageAuditLogComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Default) },
    },
}
